/**
 * Every word on the member app's front door, in one place (`MEM-046`).
 *
 * The copy is transcribed from `Member App.dc.html`'s WELCOME screen rather than written, so it
 * lives as constants for the reason the rest of this app's copy does: a test can assert the
 * screen says what the design says, and a change to the words is a change somebody has to make on
 * purpose.
 *
 * The one exception is {@link BROWSE_WITHOUT_AN_ACCOUNT}, which the prototype has no equivalent
 * for. Its header says why.
 */

/** The headline. `MEM-046` AC-1. */
export const WELCOME_HEADLINE = 'One conversation can spark something real.';

/** The line beneath it. `MEM-046` AC-1. */
export const WELCOME_SUBHEAD =
  'Intentional matches before the event. A warm way to follow up after.';

/**
 * The primary action. `MEM-046` AC-2.
 *
 * The same words the registration wizard's own final button uses, which is the prototype's doing
 * and worth keeping: a person who taps "Join H2HSpark" here finishes by pressing it again, and
 * the two ends of the flow agreeing is what makes the middle feel like one thing.
 */
export const JOIN_LABEL = 'Join H2HSpark';

/** The secondary action. `MEM-046` AC-2. */
export const SIGN_IN_LABEL = 'I already have an account';

/**
 * The signpost to what continues below the hero. `MEM-046` AC-5, and **not in the prototype**.
 *
 * The prototype's WELCOME is a wall — full height, no tab bar, nothing behind it, because in the
 * prototype the member app begins at sign-up. Ours has the public Discover list behind it, which
 * `MEM-019` AC-1 requires to work with no account. A hero that fills the screen and gives no sign
 * of that is a wall with extra steps, so this line says what is there and that it costs nothing.
 */
export const BROWSE_WITHOUT_AN_ACCOUNT = 'See what’s on — no account needed';
